require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-the-most-popular-google-searches-in-2017.json") })
        }
      }, "path---tapd-in-the-most-popular-google-searches-in-2017");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-the-most-popular-google-searches-in-2017!./.cache/json/tapd-in-the-most-popular-google-searches-in-2017.json
// module id = 869
// module chunks = 231608221292675